var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"az-content pd-y-20 pd-lg-y-30 pd-xl-y-40"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"az-content-body d-flex flex-column",staticStyle:{"min-height":"600px"}},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }